import React from 'react';
import { Typography } from 'extended-oxygen-elements';

type Props = {
  children: React.ReactNode;
};

export function SummaryValue({ children }: Props) {
  return <Typography variant="body2" data-testid={'summary-value'}>{children}</Typography>;
}
